<template>
  <div class="modal-normal" v-show="show">
    <div class="modal-body">
      <p class="content">{{content}}</p>
      <div class="confirm-btn" @click="confirm">确定</div>
    </div>
  </div>
</template>
<script>
  import COVERAPP from 'assets/js/COVERAPP.js';
  export default {
    props: {
      content:{
        type: String,
        value:'请升级到最新版本的APP'
      }
    },
    data(){
      return {
        show: true
      }
    },
    methods:{
      confirm: function(){
        COVERAPP.Method.Back();
      }
    }
  }
</script>
<style lang="scss">
  .modal-normal{
    position: fixed;
    left:0;top:0;
    width: 100vw;
    height: 100vh;
    z-index: 110;
    font-size: inherit;
    background-color: rgba(0,0,0,.6);
    .modal-body{
      position: fixed;
      left: 50%;
      top: 46%;
      transform: translate(-50%, -50%);
      padding: 1em 1em 1.2em;
      width: 60vw;
      box-sizing: border-box;
      /* color: #fff; */
      background-color: rgba(255,255,255,1);
      border-radius: .5em;
      font-size: 4.266vw;
    }
    .content{
      text-align: center;
      color: #49525e;
      margin: 1em auto 1.5em;
    }
    .confirm-btn{
      display: block;
      width: 40vw;
      height: 10.66vw;
      border-radius: 10.66vw;
      line-height: 10.66vw;
      margin: 0 auto .8em;
      background-color: #ffeeee;
      color: #e65757;
      text-align: center;
      font-weight: 700;
    }
   
  }
</style>